import i18n from '../../../shared/i18n';
import BaseModel, {defineTranslatableProperties} from "../../../core/components/input-widget/BaseModel";
import _ from 'lodash';

export default class PreBidSearch extends BaseModel {
  lot_no = null;
  paddle_number = null;
  type = null;
  clerk_uuid = null;
  bidder_uuid = null;

  rules = {};

  attributeLabels = {
    lot_no: i18n.t('Lot'),
    paddle_number: i18n.t('Paddle Number'),
    type: i18n.t('Type'),
    clerk_uuid: i18n.t('Clerk'),
  };

  attributePlaceholders = this.attributeLabels;

  constructor(data = {}) {
    super();
    Object.assign(this, {...data});
  }

  toJSON() {
    let data = super.toJSON();

    delete data.bidder

    return data
  }

  getFilteredData() {
    let returnData = [];

    const data = this.toJSON();

    for (let attr in data) {
      if (data[attr]) {
        let label = this.attributeLabels[attr];
        let value = _.capitalize(data[attr]);

        let text = `${label}: ${value}`;
        returnData.push({text, attr});
      }
    }

    return returnData;
  }
}

defineTranslatableProperties(PreBidSearch);
